<template>
    <div class="container q-mb-md buttons">
        <div class="row">
            <q-btn
                flat
                round
                class="q-mr-xs"
                icon="share"
                color="secondary"
                v-close-overlay
                :label="$T('share')"
                @click.prevent="showShare=true"
            />
            <q-btn
                flat
                class="q-mr-xs"
                round
                icon="star"
                color="secondary"
                v-close-overlay
                :label="favourited?$T('remove favourite'):$T('add to favourite')"
                @click="toggleFavourite()"
            />
            <q-btn
                flat
                class="q-mr-xs"
                round
                icon="cloud_download"
                color="secondary"
                v-close-overlay
                :label="$T('download')" @click="subscribe()"
                v-if="contentId && !noDownload"
            />
        </div>

        <q-modal v-model="showShare">
            <div class="layout-padding">

                <div class="modal-close q-pa-md">
                    <q-btn
                        color="grey"
                        round
                        flat
                        size="lg"
                        icon="close"
                        @click="showShare = false"
                    />
                </div>

                <div class="q-pt-xl flex flex-center full-height">
                    <social-sharing
                        @open="showShare=false"
                        title="check it out this news"
                        :quote="shareText"
                        :description="shareText"
                        hashtags="pocket4fun,fit,g4m"
                        :url="home"
                        v-cloak inline-template>
                        <ul class="social_button">
                            <li>
                                <network network="facebook" id="facebook">
                                    <img src="../../../img/facobook_logo.png" alt="facebook" width="48" height="48" />
                                </network>
                            </li>
                            <li>
                                <network network="twitter" id="twitter">
                                    <img src="../../../img/twitter_icon.svg" width="48" height="48" />
                                </network>
                            </li>
                            <li>
                                <network network="whatsapp">
                                    <img src="../../../img/whatsapp.png" alt="whatsapp" width="48" height="48" />
                                </network>
                            </li>
                        </ul>
                    </social-sharing>
                    <social-sharing :networks="overriddenNetworks" inline-template v-if="isPhone">
                        <div>
                            <network network="custom">
                                <img src="../../../img/sms.png" alt="whatsapp" width="48" height="48" />
                            </network>
                        </div>
                    </social-sharing>
                    <social-sharing v-if="isPhone"
                        @open="showShare=false"
                        title="check it out this news"
                        :quote="home"
                        :description="home"
                        hashtags="pocket4fun,fit,g4m"
                        :url="shareText"
                        v-cloak inline-template>
                        <ul class="social_button">
                            <li>
                                <network network="email">
                                    <img src="../../../img/mail.png" alt="mail" width="48" height="48" />
                                </network>
                            </li>
                        </ul>
                    </social-sharing>
                    <social-sharing v-else
                        @open="showShare=false"
                        title="check it out this news"
                        :quote="home"
                        :description="home"
                        hashtags="pocket4fun,fit,g4m"
                        :url="shareText"
                        v-cloak inline-template>
                        <ul class="social_button">
                            <li>
                                <network network="sms">
                                    <img src="../../../img/sms.png" alt="whatsapp" width="48" height="48" />
                                </network>
                            </li>
                            <li>
                                <network network="email">
                                    <img src="../../../img/mail.png" alt="mail" width="48" height="48" />
                                </network>
                            </li>
                        </ul>
                    </social-sharing>
                </div>
            </div>
        </q-modal>
    </div>
</template>

<script>
    import {
        QBtn,
        QFab,
        QFabAction,
        QIcon,
        QModal,
        Cookies
    } from 'quasar-framework'
    import {mapGetters} from 'vuex'
    import axios from 'axios'

    export default {
        name: 'VButtons',
        props: {
            contentId: String,
            onSide: Boolean,
            noDownload: Boolean,
            contentType: String,
            item: {
                type: Object,
                required: true
            },
            downloadLink:{
              type: String,
              required:false
            }
        },
        components: {
            QBtn,
            QFab,
            QFabAction,
            QIcon,
            QModal,
        },
        data: () => ({
            overriddenNetworks: {
                "custom": {
                    "sharer": "sms:&body=@url%20@description",
                    "type": "direct"
                },
            },
            favourited:false,
            subscribed:false,
            showShare:false,
            home: `${config.appUrl}/`,
            shareText: "",
            isPhone: window.config.iphone,
            portal_base: null
        }),
        computed: {
            ...mapGetters({
                user: 'auth/user',
            })

        },
        methods: {
            subscribe() {
                if (!this.user)
                  this.$login(this.$route.path.replace("/", "").replace("/", "*"));
                if(this.downloadLink) {
                    this.$watchUser('item', this.item, true)
                    window.location.href = this.downloadLink;
                } else 
                    axios.get(`${config.appUrl}/${this.portal_base}/${this.user.id}/subscription/${this.contentType}/${this.contentId}`)
                        .then(({data}) => {
                            window.location.href = data;

                        })
                        .catch(error => {
                            if (error.response && error.response.status == 404)
                                router.replace('/404')
                            this.$loading(false)
                        })
            },
            toggleFavourite() {
                if(!this.user)
                    this.$login(this.$route.path.replace("/", "").replace("/", "*"));
                axios.post(`${config.appUrl}/${this.portal_base}/${this.user.id}/favourite/${this.contentType}/${this.contentId}/save`, {user: this.user})
                    .then(({data}) => {
                        this.favourited = data.favourited
                    })
                    .catch(error => {

                    })
            },
            checkState() {
                axios.get(`${config.appUrl}/${this.portal_base}/${this.contentType}/${this.contentId}/check`)
                    .then(({data}) => {
                        this.subscribed =data.subscribed;
                        this.favourited =data.favourite;
                    })
                    .catch(error => {
                    })
            },
            getShareText() {
                axios.get(`${config.appUrl}/${this.portal_base}/social-message`)
                    .then(({data}) => {
                        this.shareText = data.share_text;
                    })
                    .catch(error => {
                    })
            },

        },
        mounted(){
          this.portal_base = Cookies.get('portal')
          this.checkState();
          this.getShareText();
        }
    }
</script>

<style lang="stylus" >
    ul.social_button
        padding: 0
        li
            display inline
            margin 0 10px
            cursor pointer

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Buttons.vue